import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["src"]

import {
  PropType,
  ref,
  computed,
  watch,
  onBeforeMount,
} from 'vue';
import SITE_LOGO from '@/assets/site-assets/logo.png';
import {
  abbreviateName, profileImageSrc,
} from '@/helpers';
import {
  User,
} from '@/type';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileImageAvatar',
  props: {
  user: {
    type: Object as PropType<User>,
    required: true,
  },
  size: {
    type: Number,
    default: 40,
  },
  bordered: {
    type: Boolean,
    default: false,
  },
},
  emits: ["click"],
  setup(__props) {

const props = __props





const profileImage = ref('');

const abbreviatedName = computed(() => abbreviateName(props.user));

async function _setProfileImage(): Promise<void> {
  if (!props.user) {
    return;
  }
  if (props.user.role === 'admin') {
    profileImage.value = SITE_LOGO;
  } else {
    profileImage.value = await profileImageSrc(props.user);
  }
}

watch(() => props.user, () => {
  _setProfileImage();
});

onBeforeMount(async () => {
  _setProfileImage();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["avatar", {'placeholder': !profileImage.value}]),
    tabindex: "0",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click'))),
    onKeypress: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('click')))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["rounded-full", {
        'ring-1 ring-red-500 ring-offset-red-500 ring-offset-1' : __props.bordered || !profileImage.value,
        'bg-transparent text-neutral-content': !profileImage.value,
      }]),
      style: _normalizeStyle({ width: `${__props.size}px`, height: `${__props.size}px` })
    }, [
      (profileImage.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: profileImage.value,
            alt: "profile-image"
          }, null, 8, _hoisted_1))
        : (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "text-red-500",
            style: _normalizeStyle({ fontSize: `${__props.size/2}px`})
          }, _toDisplayString(_unref(abbreviatedName)), 5))
    ], 6)
  ], 34))
}
}

})